import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img 
              src="/logo.png" 
              alt="MSL Tech Solutions" 
              className="logo-image"
            />
          </Link>

          <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              <li><Link to="/" onClick={closeMobileMenu} className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
              <li><Link to="/solutions" onClick={closeMobileMenu} className={location.pathname === '/solutions' ? 'active' : ''}>Solutions</Link></li>
              <li><Link to="/industries" onClick={closeMobileMenu} className={location.pathname === '/industries' ? 'active' : ''}>Industries</Link></li>
              <li><Link to="/technology" onClick={closeMobileMenu} className={location.pathname === '/technology' ? 'active' : ''}>Technology</Link></li>
              <li><Link to="/about" onClick={closeMobileMenu} className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
              <li><Link to="/contact" onClick={closeMobileMenu} className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>
            </ul>
          </div>

          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
